import React, { useEffect } from "react";
import styled from "styles/styled_components";

import { RequestStatus } from "types/requests";

import ScheduleEnforcementSection from "components/settings/schedule_enforcement_section";
import StyledLoaderOverlay from "components/shared/styled_loader_overlay";

const StyledSettingsPage = styled.div`
  padding: ${props => props.theme.spacing.small};
  width: 100%;
`;

interface ISettingsPage {
  enforcementOn: boolean;
  gracePeriod: number;
  permalink: string;
  fetchEnforcementSettings: (permalink: string) => void;
  enforcementRequestStatus: RequestStatus;
  setEnforcementSettings: (
    permalink: string,
    enforcementOn: boolean,
    gracePeriod: number
  ) => void;
}

function SettingsPage({
  enforcementOn,
  gracePeriod,
  permalink,
  fetchEnforcementSettings,
  enforcementRequestStatus,
  setEnforcementSettings,
}: ISettingsPage) {
  useEffect(
    () => {
      fetchEnforcementSettings(permalink);
    },
    [permalink]
  );

  let content: JSX.Element;
  if (enforcementRequestStatus !== RequestStatus.SUCCESS) {
    content = (
      <StyledLoaderOverlay>
        <div>Loading...</div>
      </StyledLoaderOverlay>
    );
  } else {
    content = (
      <StyledSettingsPage>
        <ScheduleEnforcementSection
          enforcementOn={enforcementOn}
          gracePeriod={gracePeriod}
          permalink={permalink}
          setEnforcementSettings={setEnforcementSettings}
        />
      </StyledSettingsPage>
    );
  }

  return content;
}

export default SettingsPage;
